import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/internal/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  cache = new Map();

  cacheRequest(name, ob: Observable<any>, reload = false) {
    return (!reload && this.get(name)) ? of(this.get(name)) : ob.pipe(map(response => {
      this.set(name, response);
      return response;
    }));
  }

  get(name) {
    return this.cache.get(name);
  }

  set(key, value) {
    return this.cache.set(key, value);
  }
}
